<div class="content">
    <router-outlet></router-outlet>
</div>
